import React, { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import { defaultAppContextData } from "../../services";
import { useContextService } from "../../services";
import { Button } from "react-bootstrap";
import { saveFeedback } from "../../api/apimethods";
import { NotifyType } from "../../utils/app-config";
import { notify } from "../../utils";

interface IFeedbackData {
  applicationNumber: string;
  rate: number;
  comments: string;
}

function RatingFeedback() {
  const [rating, setRating] = useState<number | null>(null);
  const [comments, setComments] = useState<string>("");
  const [applicationNum, setApplicationNum] = useState<string | undefined>();
  const [pageLoader, setPageLoader] = useState<boolean>(false);
  const { getContextValueFromStorage } = useContextService();
  const contextData = getContextValueFromStorage(defaultAppContextData);
  const user = contextData.user;
  const { message } = notify();
  const { applicationNum: paramApplicationNum } = useParams<{
    applicationNum: string;
  }>();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    async function checkQueryString() {
      setPageLoader(true);
      const searchParams = new URLSearchParams(location.search);
      const appNum = searchParams.get("an") || paramApplicationNum || "";
      setApplicationNum(appNum);
      setPageLoader(false);
    }

    checkQueryString();
  }, [location.search, paramApplicationNum]);

  const handleRatingClick = (value: number) => {
    setRating(value);
  };
  const handleCommentsChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setComments(e.target.value);
  };

  const handleSubmitFeedback = async () => {
    if (rating === null) {
      message(NotifyType.Error, "Please select a rating");
      return;
    }

    const feedbackData: IFeedbackData = {
      applicationNumber: applicationNum || "",
      rate: rating,
      comments: comments,
    };

    try {
      const response = await saveFeedback(feedbackData);
      message(NotifyType.Success, "Feedback Saved Successfully");

      setTimeout(() => {
        navigate("/");
      }, 5000);
    } catch (error) {
      console.error("Error saving feedback:", error);
      message(NotifyType.Error, "Error saving feedback.");
    }
  };

  return (
    <>
      <Header />
      <div className="info-content">
        <div className="rating-feedback">
          <h2>Dear {user?.name},</h2>
          <br />
          <p>Thank you for using E-Service. Please provide your feedback</p>

          <hr />
          <h2>How satisfied are you with our service?</h2>

          <div className="rating-scale">
            <div className="rating-buttons">
              {[...Array(11)].map((_, index) => (
                <div key={index} className="rating-button-wrapper">
                  <button
                    className={`rating-button ${
                      rating === index ? "selected" : ""
                    }`}
                    onClick={() => handleRatingClick(index)}
                  >
                    {index}
                  </button>
                  {index === 0 && (
                    <span className="rating-label">Highly unsatisfied</span>
                  )}
                  {index === 10 && (
                    <span className="rating-label">Highly Satisfied</span>
                  )}
                </div>
              ))}
            </div>
          </div>

          <h3 className="comments-heading">Comments:</h3>
          <div className="comments-container">
            <textarea
              className="comments-input"
              value={comments}
              onChange={handleCommentsChange}
              placeholder="Write your comments here..."
            />
            <Button className="submited-button" onClick={handleSubmitFeedback}>
              Submit
            </Button>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default RatingFeedback;
